import { Provider } from 'components/types/LocationTypes';
import React from 'react';

type LocationProviderProps = {
	provider: Provider;
	specialty: [string, Provider[]];
	specialtyName: string;
};

const LocationProvider = (props: LocationProviderProps): JSX.Element => {
	const { provider, specialty, specialtyName } = props;

	return (
		<li className="provider-card" key={provider.FullNameAndCredentials}>
			<a href={provider.ProfileUrl.toLowerCase()} className="track-link-click">
				<img src={provider.ProviderImage} alt={provider.FullNameAndCredentials} />
				<div>
					<p className="provider-name osf-overview">{provider.FullNameAndCredentials}</p>
					{specialty && <p className="provider-specialty osf-overview">{specialtyName}</p>}
				</div>
			</a>
		</li>
	);
};

export default LocationProvider;
